import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export default function IntegrationErrors() {
  const [range, setRange] = useState("Today");
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(null);

  const dataSets = {
    Today: generatePattern(120),
    Weekly: generatePattern(140),
    Monthly: generatePattern(180),
  };

  const data = dataSets[range];

  return (
    <Card style={styles.card}>
      <Card.Body>

        {/* HEADER */}
        <div style={styles.header}>
          <strong style={styles.title}>
            Integration Error Counts (24h)
          </strong>

          <div style={{ position: "relative" }}>
            <button
              style={styles.dropdownBtn}
              onClick={() => setOpen(!open)}
            >
              <FiCalendar size={14} style={{ marginRight: 6 }} />
              {range}
            </button>

            {open && (
              <div style={styles.dropdown}>
                {["Today", "Weekly", "Monthly"].map((item) => (
                  <div
                    key={item}
                    style={styles.dropdownItem}
                    onClick={() => {
                      setRange(item);
                      setOpen(false);
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* GRID */}
        <div style={styles.grid}>
          {data.map((level, i) => (
            <div
              key={i}
              style={{
                ...styles.box,
                background: getColor(level),
                transform: hover === i ? "scale(1.15)" : "scale(1)",
                boxShadow:
                  hover === i
                    ? "0 4px 12px rgba(0,0,0,0.15)"
                    : "none",
              }}
              onMouseEnter={() => setHover(i)}
              onMouseLeave={() => setHover(null)}
            />
          ))}
        </div>

      </Card.Body>
    </Card>
  );
}

/* COLOR SYSTEM (EXACT MATCH) */
const getColor = (level) => {
  if (level === 3) return "#f2540b";   // strong orange
  if (level === 2) return "#f7a57a";   // light orange
  return "#e5e7eb";                   // grey
};

/* STRUCTURED PATTERN (LIKE IMAGE CLUSTERS) */
function generatePattern(count) {
  return Array.from({ length: count }, (_, i) => {
    if (i < 12 || (i > 25 && i < 38) || (i > 95 && i < 115)) return 3;
    if (i % 6 === 0 || i % 9 === 0) return 2;
    return 0;
  });
}

/* STYLES */
const styles = {
  card: {
    borderRadius: 5,
    border: "2px solid #eee",
    padding: 14,
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  title: {
    fontWeight: 650,
    fontSize: 16,
  },

  dropdownBtn: {
    border: "1px solid #e5e7eb",
    padding: "6px 12px",
    borderRadius: 8,
    background: "#fff",
    fontSize: 13,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },

  dropdown: {
    position: "absolute",
    top: 40,
    right: 0,
    background: "#fff",
    borderRadius: 10,
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    overflow: "hidden",
    zIndex: 10,
    minWidth: 140,
  },

  dropdownItem: {
    padding: "10px 14px",
    fontSize: 14,
    cursor: "pointer",
  },

  /* 🔥 BIGGER CELLS (FIXED) */
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(22px, 1fr))",
    gap: "8px",
    marginTop: 20,
  },

  box: {
    width: "130%",
    padding:"14px",
    borderRadius: "6px",
    transition: "all 0.2s ease",
  },
};